import React from 'react';
import SectionMessage from '@atlaskit/section-message';
import Button from '@atlaskit/button';
import { styled } from 'styled-components';
import { colors } from '@atlaskit/theme';
import { Dimensions } from 'components/visuals';
import t from 'modules/i18n/intl';
import { messages } from '../messages';
import { DcAppParentMappingUploadResult } from '../duck/api/fetchDcAppParentMapping';

const WarningWrapper = styled.div`
  margin: ${Dimensions.units(1.5)}px 0;
`;

const FailedMappingsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: ${Dimensions.units(1.5)}px 0;
`;

const Th = styled.th`
  text-align: left;
  padding: ${Dimensions.units(1)}px;
  border-bottom: 1px solid ${colors.N40};
`;

const Td = styled.td`
  padding: ${Dimensions.units(1)}px;
  border-bottom: 1px solid ${colors.N20};
  vertical-align: top;
`;

type Props = {
  uploadResult: DcAppParentMappingUploadResult;
  onDownloadFailed: () => void;
};

const DcAppParentMappingUploadWarning = ({ uploadResult, onDownloadFailed }: Props) => {
  if (!uploadResult || uploadResult.failureCount <= 0) {
    return null;
  }

  return (
    <WarningWrapper>
      <SectionMessage appearance="warning">
        <p>
          <strong>{t(messages.dcAppParentMappingUploadWarningTitle)}</strong>
        </p>
        <FailedMappingsTable>
          <thead>
            <tr>
              <Th>{t(messages.dcAppParentMappingUploadWarningTableAppAccountId)}</Th>
              <Th>{t(messages.dcAppParentMappingUploadWarningTableParentAccountId)}</Th>
              <Th>{t(messages.dcAppParentMappingUploadWarningTableError)}</Th>
            </tr>
          </thead>
          <tbody>
            {uploadResult.failedMappings.map((item, index) => (
              <tr key={`${index}-${item.appAccountId}-${item.parentAccountId ?? ''}`}>
                <Td>{item.appAccountId}</Td>
                <Td>{item.parentAccountId ?? ''}</Td>
                <Td>{item.errorMessage}</Td>
              </tr>
            ))}
          </tbody>
        </FailedMappingsTable>
        <Button appearance="link" onClick={onDownloadFailed} spacing="none">
          {t(messages.dcAppParentMappingUploadWarningDownloadFailed)}
        </Button>
      </SectionMessage>
    </WarningWrapper>
  );
};

export default DcAppParentMappingUploadWarning;
